import { useState, useEffect } from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import { useLocation, useHistory } from "react-router-dom";
import { Helmet } from 'react-helmet-async'
import { AppHeader } from '../../common/app-header'
import { checkSize, convertFileToBase64, intervalId } from '../../common/support-util'

import axios from "axios";
import {
  ErrorInfo,
  required,
  emailRegexp,
  maxLength,
} from "../../common/Validator";

interface ReportGroupForm {
  email: string;
  category: string;
  message?: string | null;
  file: any | null;
  gid: string;
}

interface Category {
  category: string;
  title: string;
}

export const ReportGroup = () => {
  const search = useLocation().search;
  const [hide, setHide] = useState(false)
  const [categories, setCategories] = useState<Category[]>();
  const [btnClz, setBtnClz] = useState(["btnSubmit"])
  const history = useHistory();
  const query = new URLSearchParams(search);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<ReportGroupForm>();
  const gid = query.get("gid");

  // 送信処理
  const onSubmit: SubmitHandler<ReportGroupForm> = async (
    data: ReportGroupForm
  ) => {
    const sendData = {
      ...data,
      // 画像をdataurlに変換して更新
      file: await convertFileToBase64(data.file),
      gid,
    };

    setBtnClz([...btnClz, "sending"])// くるくるアイコン
    axios.post("/api/v1/sp/app/report/group", sendData)
      .then(() => {
        setHide(true)
        clearInterval(intervalId)
      })
      .catch(() => history.push("/errors/400"));
  };

  useEffect(() => {
    
    // useEffectではasync-awaitが使えないのでcallback形式で書く
    axios.get("/api/v1/sp/app/report/group/const")
        .then((result) => {
            setCategories(result.data?.categories)
        })
        .catch((e) => history.push("/errors/400"));

}, [history]);

  return (
    <>
      <Helmet title="グループ通報 | Family Works" />
      <div className='contact'>
        <div className="bodywrap">
          <AppHeader titleText="グループ通報" />

          <main className="wrapper">
            {!hide && <>
              <p className="contactExplain"><span className="kome">&#8251;</span>は必須項目です。</p>
              <section className="secContact">
                <form id="formContact" onSubmit={handleSubmit(onSubmit)}>
                  <ul className="formlist">
                    <li className="formlist__half">
                      <dl>
                        <dt><label htmlFor="frm-category">通報の種類 <span className="kome">&#8251;</span></label></dt>
                        <dd>
                          <select
                            {...register("category", { required })}
                            id="frm-category" tabIndex={1} autoFocus defaultValue="SUSPICIOUS_PERSON">
                            {categories?.map((item, idx) => (
                                <option value={item.category} key={idx}>
                                    {item.title}
                                </option>
                            ))}
                          </select>
                        </dd>
                        <ErrorInfo error={errors.category} />
                      </dl>
                    </li>
                    <li className="required">
                      <dl>
                        <dt><label htmlFor="frm-email">メールアドレス <span className="kome">&#8251;</span></label></dt>
                        <dd><input
                          {...register("email", {
                            required,
                            pattern: emailRegexp,
                            ...maxLength(254),
                          })}
                          maxLength={254}
                          type="email" id="frm-email" placeholder="メールアドレス" tabIndex={2} /></dd>
                        <ErrorInfo error={errors.email} />
                      </dl>
                    </li>
                    <li className="formlist__full required">
                      <dl>
                        <dt><label htmlFor="frm-msg">通報内容 <span className="kome">&#8251;</span></label></dt>
                        <dd><textarea {...register("message")} id="frm-msg" cols={50} rows={5} placeholder="通報内容" tabIndex={3}></textarea></dd>
                        <ErrorInfo error={errors.message} />
                      </dl>
                    </li>
                    <li>
                      <dl>
                        <dt><label htmlFor="frm-attached">画像ファイル (最大10MB)</label></dt>
                        <dd><input
                          {...register("file", {
                            validate: {
                              lessThan10Mb: (v) => checkSize(v),
                            },
                          })}
                          type="file"
                          accept="image/jpeg, image/png, image/gif"
                          id="frm-attached" tabIndex={4} /></dd>
                        <ErrorInfo error={errors.file} />
                      </dl>
                    </li>
                  </ul>
                  <div className={btnClz.join(' ')}>
                    <div className="iconSpinner"></div>
                    <input type="submit" name="submit" value="送信" tabIndex={8} />
                  </div>
                </form>
                <p className="contactNote">親族間でのトラブルによるご相談はお受けすることが出来ませんので、ご了承ください。</p>
              </section>
            </>}
            {hide && <>
              <section className="secContactSent">
                <p className="secContactSent__title">送信されました。</p>
                <p className="secContactSent__txt">グループ通報を受け付けました。</p>
              </section>
            </>}
          </main>
        </div>
      </div>
    </>
  );
};
